/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { CLICKABLE_REGION_REGEX } from '../util'
import MCPOption from './multiple_choice_poll_option'
import _ from 'underscore'

const FLOATING_POINT_REGEX = /^-?\d{0,3}(\.\d{1,2})?$/

// @namespace Model
export default class ClickableImageRegion extends MCPOption {
  static get CLICKABLE_REGION_OTHER () { return 'region:other' }
  static get CLICKABLE_REGION_DEFAULT_WIDTH () { return 65 }
  static get CLICKABLE_REGION_DEFAULT_HEIGHT () { return 65 }
  static get CLICKABLE_REGION_MIN_WIDTH () { return 20 }
  static get CLICKABLE_REGION_MIN_HEIGHT () { return 20 }

  // For backwards compatability, moved to Util to resolve circular dep in _images
  static get CLICKABLE_REGION_REGEX () { return CLICKABLE_REGION_REGEX }

  initialize () {
    super.initialize(...arguments)

    return this.on('change:value', () => {
      return delete this.regionMatches
    })
  }

  /*
   * Validate the points are numeric
   *
   */
  validate (attrs) {
    if (attrs.points && !FLOATING_POINT_REGEX.test(attrs.points)) {
      return 'Invalid points'
    }
  }

  contains (value) {
    const region = new ClickableImageRegion({ value: value + '|0.1%x0.1%' })

    return this.overlaps(region)
  }

  resolveOverlaps (regions) {
    return regions.each(region => {
      if (this.overlaps(region)) {
        this.separateFrom(region)

        return this.trigger('reposition')
      }
    })
  }

  revertIfInvalid (toPosition) {
    let invalid = false

    this.collection.collidableRegions(this).each(region => {
      const invalidPlacement = this.overlaps(region) || this.outsideContainer()

      if (invalidPlacement) {
        this.set({ value: toPosition })
        this.trigger('reposition')
        invalid = true
      }
    })

    return invalid
  }

  outsideContainer () {
    const b = this.bounds()

    return (b.left < 0) || (b.right > 100) || (b.top < 0) || (b.bottom > 100)
  }

  isOtherRegion () {
    return this.get('value') === ClickableImageRegion.CLICKABLE_REGION_OTHER
  }

  containsRelativeXY (relativeX, relativeY, imageWidth, imageHeight) {
    if (this.isOtherRegion()) {
      return false
    } else {
      // convert to absolutes now
      const targetX = relativeX * imageWidth
      const targetY = relativeY * imageHeight

      const regionX = (this.relativeX() / 100) * imageWidth
      const regionY = (this.relativeY() / 100) * imageHeight

      const regionWidth = (this.relativeWidth() / 100) * imageWidth
      const regionHeight = (this.relativeHeight() / 100) * imageHeight

      const insideX = (targetX > regionX) && (targetX < (regionX + regionWidth))
      const insideY = (targetY > regionY) && (targetY < (regionY + regionHeight))

      return insideX && insideY
    }
  }

  relativeWidth () {
    if (this.regionMatches == null) { this.regionMatches = __guard__(this.get('value'), x => x.match(CLICKABLE_REGION_REGEX)) }
    if ((this.regionMatches != null ? this.regionMatches.length : undefined) > 4) { return parseFloat(this.regionMatches[4]) }
  }

  relativeHeight () {
    if (this.regionMatches == null) { this.regionMatches = __guard__(this.get('value'), x => x.match(CLICKABLE_REGION_REGEX)) }
    if ((this.regionMatches != null ? this.regionMatches.length : undefined) > 5) { return parseFloat(this.regionMatches[5]) }
  }

  respondWithCoord (relativeX, relativeY) {
    return this.respond(`region: ${relativeX * 100}%,${relativeY * 100}%`)
  }

  center () {
    return {
      x: this.relativeX() + (this.relativeWidth() / 2),
      y: this.relativeY() + (this.relativeHeight() / 2)
    }
  }

  size () {
    return {
      width: this.relativeWidth(),
      height: this.relativeHeight()
    }
  }

  bounds () {
    return {
      left: this.relativeX(),
      right: this.relativeX() + this.relativeWidth(),
      top: this.relativeY(),
      bottom: this.relativeY() + this.relativeHeight()
    }
  }

  overlaps (region) {
    // The "other" region has no XY coordinates. Thus it never overlaps.
    if (region.isOtherRegion() || this.isOtherRegion()) { return false }

    const { left: l1, right: r1, top: t1, bottom: b1 } = this.bounds()
    const { left: l2, right: r2, top: t2, bottom: b2 } = region.bounds()

    return !((l2 > r1) || (r2 < l1) || (t2 > b1) || (b2 < t1))
  }

  separateFrom (region) {
    let direction = 1.05

    const { width: rWidth, height: rHeight } = region.size()
    const { x: rX, y: rY } = region.center()

    const { width, height } = this.size()
    const { x, y } = this.center()
    let { left, top } = this.bounds()

    const overlapX = ((width + rWidth) / 2) - Math.abs(x - rX)
    const overlapY = ((height + rHeight) / 2) - Math.abs(y - rY)

    if (overlapY > overlapX) {
      if (x <= rX) { direction = -direction }
      left += (direction * overlapX)

      return this.updateValue({ x: left })
    } else {
      if (y <= rY) { direction = -direction }
      top += (direction * overlapY)

      return this.updateValue({ y: top })
    }
  }

  updateValue ({ x, y, width, height, name }) {
    const bounds = this.bounds()
    const size = this.size()

    if (x == null) { x = bounds.left }
    if (y == null) { y = bounds.top }

    if (width == null) { ({ width } = size) }
    if (height == null) { ({ height } = size) }

    if (name == null) { name = this.getName() }

    return this.set({ value: `region: ${x}%,${y}%|${width}%x${height}%\#${name}` }) // eslint-disable-line no-useless-escape
  }

  setName (name) {
    const value = this.get('value')
    this.set({ value: value.replace(/#.*$/, '') + `\#${name}` }) // eslint-disable-line no-useless-escape
    return this.trigger('rename')
  }

  getName () {
    if (this.regionMatches == null) { this.regionMatches = __guard__(this.get('value'), x => x.match(CLICKABLE_REGION_REGEX)) }
    if ((this.regionMatches != null ? this.regionMatches.length : undefined) > 5) { return this.regionMatches[6] }
  }

  toJSON () {
    return _.pick(this.attributes,
      '_destroy',
      'id',
      'value',
      'correct_response',
      'points')
  }
}

function __guard__ (value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}
